import Model from '@models/model'
import { START_UNIFIED_ONBOARDING } from './unifiedOnboarding/graphql/startUnifiedOnboarding'
import { COMPLETE_UNIFIED_ONBOARDING } from './unifiedOnboarding/graphql/completeUnifiedOnboarding'
import { UnifiedOnboardingStoreState } from './unifiedOnboarding/types'
import { UNIFIED_ONBOARDING_UPSELL_OFFERS } from './unifiedOnboarding/graphql/unifiedOnboardingUpsellOffers'
import { reducers } from './unifiedOnboarding/reducers'
import { UnifiedOnboardingUpsellOffersQuery } from './unifiedOnboarding/graphql/unifiedOnboardingUpsellOffers.generated'

export default class UnifiedOnboarding {
  namespace = 'unifiedOnboarding'

  state: UnifiedOnboardingStoreState = {
    ...Model.defaultState,
    upsellOffers: [],
  }

  effects = {
    start: Model.buildEffect({
      name: `${this.namespace}/start`,
      query: START_UNIFIED_ONBOARDING,
      dataPath: 'startUnifiedOnboarding',
    }),

    complete: Model.buildEffect({
      name: `${this.namespace}/complete`,
      query: COMPLETE_UNIFIED_ONBOARDING,
      dataPath: 'completeUnifiedOnboarding',
    }),

    fetchUpsellOffers: Model.buildEffect({
      name: `${this.namespace}/fetchUpsellOffers`,
      query: UNIFIED_ONBOARDING_UPSELL_OFFERS,
      dataPath: 'unifiedOnboardingUpsellOffers',
      reducers: [
        {
          name: 'setUpsellOffers',
          payload: (
            response: UnifiedOnboardingUpsellOffersQuery['unifiedOnboardingUpsellOffers'],
          ) => response.upsellOffers,
        },
      ],
    }),
  }

  reducers = {
    ...Model.defaultReducers,
    ...reducers,
  }
}
